import React from 'react';
import { Check } from 'lucide-react';
import { RADIUS, useTheme } from '../../theme';
import { baseButton } from './shared';

/**
 * Valbar pill (filter, snabbval, utrustning), 44 px hög.
 * Vald = accentSoft + accentText med bock; ovald = yta med kontur.
 */
export function Chip({ selected, onClick, children, icon, count, title, disabled }: {
  selected?: boolean; onClick?: () => void; children: React.ReactNode; icon?: React.ReactNode; count?: number; title?: string; disabled?: boolean;
}) {
  const T = useTheme();
  return (
    <button type="button" aria-pressed={selected} onClick={onClick} title={title} disabled={disabled}
      style={{
        ...baseButton, minHeight: 44, padding: '0 14px', gap: 6, borderRadius: RADIUS.pill, fontSize: 14, fontWeight: 600,
        background: selected ? T.accentSoft : T.surface, color: selected ? T.accentText : T.text,
        border: `1px solid ${selected ? T.accentFill : T.borderHover}`, opacity: disabled ? 0.55 : 1,
      }}>
      {selected ? <Check size={16} strokeWidth={2.5} aria-hidden /> : icon}
      {children}
      {count != null && <span style={{ fontSize: 12, fontWeight: 700, color: selected ? T.accentText : T.textMuted }}>{count}</span>}
    </button>
  );
}
